import auth from "./auth/reducer";
import themeChanger from "./themeChanger/reducer";
import LanguageSwitcher from "./languageSwitcher/reducer";
import themeSetting from "./themeSettings/reducer";
import scrumboard from "./scrumboard/reducer";
import report from "./listReport/reducer";
import { combineReducers } from "redux";

const createReducer = asyncReducers =>
  combineReducers({
    auth,
    themeChanger,
    LanguageSwitcher,
    themeSetting,
    scrumboard,
    report,
    ...asyncReducers
  });

export default createReducer;
